// getIdols returns all the idols for a specific gender
export const IdolV1_getIdolsLazy = () =>
  import("./idol_v1.grpc").then((m) => m.IdolV1_getIdols);
IdolV1_getIdolsLazy.method = "idol.IdolV1/getIdols" as const;

// getIdolsById returns the detailed idol information for the given Ids
export const IdolV1_getIdolsByIdLazy = () =>
  import("./idol_v1.grpc").then((m) => m.IdolV1_getIdolsById);
IdolV1_getIdolsByIdLazy.method = "idol.IdolV1/getIdolsById" as const;

// likeIdol likes a specific idol for the current customer
export const IdolV1_likeIdolLazy = () =>
  import("./idol_v1.grpc").then((m) => m.IdolV1_likeIdol);
IdolV1_likeIdolLazy.method = "idol.IdolV1/likeIdol" as const;

// unlikeIdol unlikes a specific idol for the current customer
export const IdolV1_unlikeIdolLazy = () =>
  import("./idol_v1.grpc").then((m) => m.IdolV1_unlikeIdol);
IdolV1_unlikeIdolLazy.method = "idol.IdolV1/unlikeIdol" as const;
